import styles from "./SwitchInput.module.css";
import { useState } from "react";

function SwitchInput({ value, onChange, onMouseUp, ...props }) {
    const [isChecked, setIsChecked] = useState(value);
    return (
        <div className={styles.inputContainer}>
            <input className={styles.onOffCheck} type="checkbox" checked={isChecked === true} onMouseUp={(e) => { onMouseUp && onMouseUp(e) }} onChange={(e) => { setIsChecked((prev) => !prev); onChange && onChange(e) }} {...props} />
        </div>
    )
}

export default SwitchInput;